import { BaseGridRenderer, GridRenderOptions } from './base-grid-renderer';
import { RowJsonData } from '../../models/element-types';
import { ColumnRenderer } from './column-renderer';

export interface RowRenderOptions extends GridRenderOptions {
    renderColumns?: boolean;
}

export class RowRenderer extends BaseGridRenderer<RowJsonData> {
    private readonly maxColumns = 12;
    private readonly columnRenderer = new ColumnRenderer();

    protected get defaultData(): RowJsonData {
        return {
            id: '',
            type: 'row'
        };
    }

    public override createNew(options?: RowRenderOptions): HTMLElement {
        const element = super.createNew(options);

        if (!options || options.renderColumns !== false) {
            const idsBlackList = [element.id];
            for (let i = 0; i < this.maxColumns; i++) {
                const column = this.columnRenderer.createNew({
                    size: 1,
                    empty: true,
                    idsBlackList
                });
                element.append(column);
                idsBlackList.push(column.id);
            }
        }

        return element;
    }

    protected renderElement(rowJsonData: RowJsonData): HTMLElement {
        const element = document.createElement('div');
        element.id = rowJsonData.id;
        element.classList.add('mesh-row', 'empty');
        element.dataset['meshRow'] = '';

        return element;
    }
}
